// New json with industries of latest wp site Dont touch the file this is backup
export const NewMenuData = {
    "header": {
        "topbar": {
            "left": {
                "join_team": {
                    "text": "Join Our Team",
                    "dropdown": {
                        "sections": [
                            {
                                "title": "Get to Know Us",
                                "links": [
                                    {
                                        "text": "Our Culture",
                                        "href": "https://www.trinityconsultants.com/culture-expertise/"
                                    },
                                    {
                                        "text": "Code of Conduct",
                                        "href": "https://www.trinityconsultants.com/wp-content/uploads/Trinity-Consultants-Code-of-Business-Conduct.pdf"
                                    },
                                    {
                                        "text": "Mergers and Acquisition",
                                        "href": "https://www.trinityconsultants.com/mergers-acquisitions/"
                                    }
                                ]
                            },
                            {
                                "title": "Career Opportunities",
                                "links": [
                                    {
                                        "text": "Opportunities at Trinity",
                                        "href": "https://www.trinityconsultants.com/careers/"
                                    },
                                    {
                                        "text": "Submit a Resume",
                                        "href": "mailto:recruitment@trinityconsultants.com"
                                    }
                                ]
                            }
                        ],
                        "featured_content": {
                            "title": "Put Your Degree to Work",
                            "description": "We assist clients through a combination of consulting support, technology-based solutions, professional training, and staffing services.",
                            "cta": {
                                "text": "View Open Positions",
                                "href": "https://www.linkedin.com/company/trinity-consultants/jobs/?viewAsMember=true"
                            }
                        }
                    }
                },
                "subscribe": {
                    "text": "Subscribe",
                    "href": "https://www.trinityconsultants.com/subscribe-now/"
                }
            },
            "right": {
                "search": {
                    "text": "Explore",
                    "icons": {
                        "white": "https://trinityconsdev.wpenginepowered.com/wp-content/themes/genesis-block-theme/images/search_icon_explore.svg",
                        "dark": "https://trinityconsdev.wpenginepowered.com/wp-content/themes/genesis-block-theme/images/dark_search_icon.svg"
                    },
                    "search_overlay": {
                        "title": "Explore",
                        "form": {
                            "action": "https://www.trinityconsultants.com/",
                            "method": "get",
                            "placeholder": "Search insight, news, services, experts, etc."
                        },
                        "popular_searches": [
                            "Env",
                            "Article",
                            "news",
                            "blog",
                            "env",
                            "test"
                        ],
                        "recent_pages": [
                            {
                                "text": "Home",
                                "href": "https://www.trinityconsultants.com/"
                            }
                        ]
                    }
                }
            }
        },
        "main_navigation": {
            "logo": {
                "href": "https://www.trinityconsultants.com/",
                "src": "https://trinityconsdev.wpenginepowered.com/wp-content/uploads/Vector.webp",
                "alt": "Logo",
                "width": "122",
                "height": "32"
            },
            "mega_menu": {
                "logo": "https://trinityconsdev.wpenginepowered.com/wp-content/themes/genesis-block-theme/images/trinity_color_logo_new.png",
                "menu_items": [
                    {
                        "id": "expertise",
                        "title": "Expertise",
                        "href": "#",
                        "type": "megamenu",
                        "content": {
                            "title": "Divisions",
                            "description": "Our specialized consulting teams operate across four strategic divisions, delivering expert guidance and tailored solutions to drive impactful results.",
                            "divisions": [
                                {
                                    "code": "EC",
                                    "title": "Environmental Consulting",
                                    "href": "https://www.trinityconsultants.com/environmental-consulting/",
                                    "services": [
                                        {
                                            "text": "Air Quality",
                                            "href": "https://www.trinityconsultants.com/service-area/air-quality/"
                                        },
                                        {
                                            "text": "Chemical Compliance",
                                            "href": "https://www.trinityconsultants.com/service-area/chemical-compliance/"
                                        },
                                        {
                                            "text": "Sustainability",
                                            "href": "https://trinityconsultants.com/service-area/esg-and-sustainability/"
                                        },
                                        {
                                            "text": "Process Safety",
                                            "href": "https://www.trinityconsultants.com/service-area/process-safety/"
                                        },
                                        {
                                            "text": "Land Use & Impact Analysis",
                                            "href": "https://www.trinityconsultants.com/service-area/land-use-and-impact-analysis/"
                                        }
                                    ],
                                    "view_all": {
                                        "text": "View All EC Services",
                                        "href": "https://www.trinityconsultants.com/environmental-consulting/#expertise_sec"
                                    }
                                },
                                {
                                    "code": "WE",
                                    "title": "Water & Ecology",
                                    "href": "https://www.trinityconsultants.com/water-ecology/",
                                    "services": [
                                        {
                                            "text": "Environmental Planning & Assessments",
                                            "href": "https://www.trinityconsultants.com/service-area/environmental-planning-assessments/"
                                        },
                                        {
                                            "text": "Regulatory & Environmental Compliance",
                                            "href": "https://www.trinityconsultants.com/service-area/regulatory-environmental-compliance/"
                                        },
                                        {
                                            "text": "Cultural Resources & Indigenous Engagement",
                                            "href": "https://www.trinityconsultants.com/service-area/cultural-resources-indigenous-engagement/"
                                        },
                                        {
                                            "text": "Fisheries, Aquatic & Marine",
                                            "href": "https://www.trinityconsultants.com/service-area/fisheries-aquatic-marine/"
                                        },
                                        {
                                            "text": "Wetlands, Wildlife, Terrestrial & Ecology",
                                            "href": "https://www.trinityconsultants.com/service-area/wildlife-wetlands-terrestrial-ecology/"
                                        }
                                    ],
                                    "view_all": {
                                        "text": "View All WE Services",
                                        "href": "https://www.trinityconsultants.com/water-ecology/#expertise_sec"
                                    }
                                },
                                {
                                    "code": "BE",
                                    "title": "Built Environment",
                                    "href": "https://www.trinityconsultants.com/built-environment/",
                                    "services": [
                                        {
                                            "text": "Building Commissioning",
                                            "href": "https://www.trinityconsultants.com/service-area/building-commissioning/"
                                        },
                                        {
                                            "text": "Acoustic Design & Engineering",
                                            "href": "https://www.trinityconsultants.com/service-area/acoustic-design-and-engineering/"
                                        },
                                        {
                                            "text": "Building Technology & Security",
                                            "href": "https://www.trinityconsultants.com/service-area/building-technology-security/"
                                        },
                                        {
                                            "text": "Building Compliance & Regulatory Support",
                                            "href": "https://www.trinityconsultants.com/service-area/be-building-compliance-regulatory-support/"
                                        },
                                        {
                                            "text": "Facility Operations",
                                            "href": "https://www.trinityconsultants.com/service-area/facility-operations/"
                                        }
                                    ],
                                    "view_all": {
                                        "text": "View All BE Services",
                                        "href": "https://www.trinityconsultants.com/built-environment/#expertise_sec"
                                    }
                                },
                                {
                                    "code": "LS",
                                    "title": "Life Sciences",
                                    "href": "https://www.trinityconsultants.com/life-sciences/",
                                    "services": [
                                        {
                                            "text": "Pharmaceutical Toxicology",
                                            "href": "https://www.trinityconsultants.com/service-area/pharmaceutical-toxicology/"
                                        },
                                        {
                                            "text": "Process, Engineering & CQV",
                                            "href": "https://www.trinityconsultants.com/service-area/process-engineering-cqv/"
                                        },
                                        {
                                            "text": "Automation & Operational Technology",
                                            "href": "https://www.trinityconsultants.com/service-area/automation-and-operational-technology/"
                                        },
                                        {
                                            "text": "Healthcare, Cleanroom & Research Facilities",
                                            "href": "https://www.trinityconsultants.com/service-area/healthcare-cleanroom-research-facilities/"
                                        },
                                        {
                                            "text": "Food, Beverage & Chemical Toxicology",
                                            "href": "https://www.trinityconsultants.com/service-area/food-beverage-chemical-toxicology/"
                                        }
                                    ],
                                    "view_all": {
                                        "text": "View All LS Services",
                                        "href": "https://www.trinityconsultants.com/life-sciences/#expertise_sec"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "id": "industries",
                        "title": "Industries",
                        "href": "https://www.trinityconsultants.com/industries/",
                        "type": "megamenu",
                        "content": {
                            "title": "Industries",
                            "categories": [
                                {
                                    "title": "COMMERCIAL & INSTITUTIONAL",
                                    "items": [
                                        {
                                            "text": "Building Construction",
                                            "href": "https://trinityconsultants.com/industries/building-construction/"
                                        },
                                        {
                                            "text": "Corporate Offices",
                                            "href": "https://trinityconsultants.com/industries/corporate-offices/"
                                        },
                                        {
                                            "text": "Data Centers",
                                            "href": "https://trinityconsultants.com/industries/data-centers/"
                                        },
                                        {
                                            "text": "IT Services & Consulting",
                                            "href": "https://trinityconsultants.com/industries/it-services-consulting/"
                                        },
                                        {
                                            "text": "Law & Legal Services",
                                            "href": "https://trinityconsultants.com/industries/law-and-legal-services/"
                                        },
                                        {
                                            "text": "Multi-Use Event Centers",
                                            "href": "https://trinityconsultants.com/industries/multi-use-event-centers/"
                                        },
                                        {
                                            "text": "Museums, Arts & Culture",
                                            "href": "https://trinityconsultants.com/industries/museums-arts-and-culture/"
                                        },
                                        {
                                            "text": "Performing Arts Centers",
                                            "href": "https://trinityconsultants.com/industries/performing-arts-centers/"
                                        },
                                        {
                                            "text": "Real Estate Development",
                                            "href": "https://trinityconsultants.com/industries/real-estate-development/"
                                        },
                                        {
                                            "text": "Retail & Hospitality",
                                            "href": "https://trinityconsultants.com/industries/retail-hospitality/"
                                        }
                                    ]
                                },
                                {
                                    "title": "ENERGY & UTILITIES",
                                    "items": [
                                        {
                                            "text": "Electric Power",
                                            "href": "https://trinityconsultants.com/industries/electric-power/"
                                        },
                                        {
                                            "text": "Oil & Gas",
                                            "href": "https://trinityconsultants.com/industries/oil-gas/"
                                        },
                                        {
                                            "text": "Petroleum Refining",
                                            "href": "https://trinityconsultants.com/industries/petroleum-refining/"
                                        },
                                        {
                                            "text": "Renewable Energy",
                                            "href": "https://trinityconsultants.com/industries/renewable-energy/"
                                        },
                                        {
                                            "text": "Tanks & Terminals",
                                            "href": "https://trinityconsultants.com/industries/tanks-terminals/"
                                        },
                                        {
                                            "text": "Water & Wastewater Utilities",
                                            "href": "https://trinityconsultants.com/industries/water-wastewater-utilities/"
                                        }
                                    ]
                                },
                                {
                                    "title": "EDUCATION FACILITIES",
                                    "items": [
                                        {
                                            "text": "Higher Education",
                                            "href": "https://trinityconsultants.com/industries/education-facilities/"
                                        }
                                    ]
                                },
                                {
                                    "title": "TRANSPORTATION & LOGISTICS",
                                    "items": [
                                        {
                                            "text": "Airports & Travel Hubs",
                                            "href": "https://trinityconsultants.com/industries/airports-and-travel-hubs/"
                                        },
                                        {
                                            "text": "Ground Transportation",
                                            "href": "https://trinityconsultants.com/industries/ground-transportation/"
                                        },
                                        {
                                            "text": "Deepwater Ports & Offshore",
                                            "href": "https://trinityconsultants.com/industries/deepwater-ports-offshore/"
                                        },
                                        {
                                            "text": "Railroads & Rail Yards",
                                            "href": "https://trinityconsultants.com/industries/railroads-and-rail-yards/"
                                        },
                                        {
                                            "text": "Warehousing",
                                            "href": "https://trinityconsultants.com/industries/warehousing/"
                                        }
                                    ]
                                },
                                {
                                    "title": "GOVERNMENT & PUBLIC SECTOR",
                                    "items": [
                                        {
                                            "text": "Conservation Programs",
                                            "href": "https://trinityconsultants.com/industries/conservation-programs/"
                                        },
                                        {
                                            "text": "Federal, State & Provincial",
                                            "href": "https://trinityconsultants.com/industries/federal-state-provincial/"
                                        },
                                        {
                                            "text": "Indigenous Communities",
                                            "href": "https://trinityconsultants.com/industries/indigenous-communities/"
                                        },
                                        {
                                            "text": "Infrastructure",
                                            "href": "https://trinityconsultants.com/industries/infrastructure/"
                                        }
                                    ]
                                },
                                {
                                    "title": "MINING & NATURAL RESOURCES",
                                    "items": [
                                        {
                                            "text": "Environmental Restoration",
                                            "href": "https://trinityconsultants.com/industries/environmental-restoration/"
                                        },
                                        {
                                            "text": "Minerals & Aggregates",
                                            "href": "https://trinityconsultants.com/industries/minerals-aggregates/"
                                        },
                                        {
                                            "text": "Mining",
                                            "href": "https://trinityconsultants.com/industries/mining/"
                                        },
                                        {
                                            "text": "Pulp & Paper Products",
                                            "href": "https://trinityconsultants.com/industries/pulp-paper-products/"
                                        }
                                    ]
                                },
                                {
                                    "title": "HEALTHCARE & LIFE SCIENCES",
                                    "items": [
                                        {
                                            "text": "Clinical & Diagnostic Labs",
                                            "href": "https://trinityconsultants.com/industries/clinical-diagnostic-labs/"
                                        },
                                        {
                                            "text": "Hospitals & Medical Centers",
                                            "href": "https://trinityconsultants.com/industries/hospitals-and-medical-centers/"
                                        },
                                        {
                                            "text": "Biotech/Pharma R&D",
                                            "href": "https://trinityconsultants.com/industries/life-sciences-research/"
                                        },
                                        {
                                            "text": "Pharmaceutical Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/pharmaceutical-manufacturing/"
                                        }
                                    ]
                                },
                                {
                                    "title": "MANUFACTURING & INDUSTRIAL",
                                    "items": [
                                        {
                                            "text": "Aerospace Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/aerospace-manufacturing/"
                                        },
                                        {
                                            "text": "Agricultural Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/agricultural-manufacturing/"
                                        },
                                        {
                                            "text": "Automotive Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/automotive-manufacturing/"
                                        },
                                        {
                                            "text": "Battery Manufacturing & Recycling",
                                            "href": "https://trinityconsultants.com/industries/battery-manufacturing-recycling/"
                                        },
                                        {
                                            "text": "Building Products Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/building-products/"
                                        },
                                        {
                                            "text": "Chemical Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/chemical-manufacturing/"
                                        },
                                        {
                                            "text": "Food & Beverage Processing",
                                            "href": "https://trinityconsultants.com/industries/food-beverage-processing/"
                                        },
                                        {
                                            "text": "General Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/general-manufacturing/"
                                        },
                                        {
                                            "text": "Lime Production",
                                            "href": "https://trinityconsultants.com/industries/lime-production/"
                                        },
                                        {
                                            "text": "Metals Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/metals-manufacturing/"
                                        },
                                        {
                                            "text": "Plastics Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/plastics-manufacturing/"
                                        },
                                        {
                                            "text": "Portland Cement Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/portland-cement-manufacturing/"
                                        },
                                        {
                                            "text": "Semiconductor Manufacturing",
                                            "href": "https://trinityconsultants.com/industries/semiconductor-manufacturing/"
                                        },
                                        {
                                            "text": "Waste & Recycling Facilities",
                                            "href": "https://trinityconsultants.com/industries/waste-recycling-facilities/"
                                        }
                                    ]
                                }
                            ],
                            "view_all": {
                                "text": "View All Industries",
                                "href": "https://www.trinityconsultants.com/industries/"
                            }
                        }
                    },
                    {
                        "id": "software",
                        "title": "Software",
                        "href": "https://www.trinityconsultants.com/software/",
                        "type": "megamenu",
                        "content": {
                            "sections": [
                                {
                                    "title": "Software",
                                    "items": [
                                        {
                                            "text": "EHS / BREEZE",
                                            "href": "https://www.trinityconsultants.com/software#ehsbreeze"
                                        },
                                        {
                                            "text": "Commissioning / CxAlloy",
                                            "href": "https://www.trinityconsultants.com/software#cxalloy"
                                        },
                                        {
                                            "text": "Life Sciences / Data Analytics Dashboard",
                                            "href": "https://www.trinityconsultants.com/software#plantmetrics"
                                        }
                                    ]
                                },
                                {
                                    "title": "Software Consulting",
                                    "items": [
                                        {
                                            "text": "Digital Solutions & Implementation",
                                            "href": "https://trinityconsultants.com/digital-solutions-implementations/"
                                        },
                                        {
                                            "text": "MES System Integration",
                                            "href": "https://www.trinityconsultants.com/software/#messystems"
                                        },
                                        {
                                            "text": "PI/Data Analytics",
                                            "href": "https://trinityconsultants.com/software#dataanalytics"
                                        }
                                    ]
                                },
                                {
                                    "title": "Partners",
                                    "items": [
                                        {
                                            "text": "EHS Technology",
                                            "href": "https://trinityconsultants.com/software#ehstechnology"
                                        },
                                        {
                                            "text": "Life Sciences/MES",
                                            "href": "https://trinityconsultants.com/software#mespartners"
                                        },
                                        {
                                            "text": "Sustainability",
                                            "href": "https://trinityconsultants.com/software#sustainpartners"
                                        },
                                        {
                                            "text": "Global Partners",
                                            "href": "https://shop.trinityconsultants.com/software/global-partners/?_gl=1*pqg7vt*_gcl_au*MTMyNjM0MzYyLjE3NTkzMTMwNDg.*_ga*MTU5MjMwNjI4Ni4xNzU5MzEzMDQ4*_ga_VB50X7KQHK*czE3NjIzMjQ5ODckbzQ4JGcxJHQxNzYyMzI1NTgyJGo2MCRsMCRoMTE1MzM1OTYzNA.."
                                        }
                                    ]
                                },
                                {
                                    "title": "Support",
                                    "items": [
                                        {
                                            "text": "Maintenance & Support",
                                            "href": "https://shop.trinityconsultants.com/software/support?_gl=1*s0u805*_ga*MTU5MjMwNjI4Ni4xNzU5MzEzMDQ4*_ga_E7GRZMZZT3*czE3NjEyMTU2NTUkbzE1JGcxJHQxNzYxMjE2OTkzJGo1OCRsMCRoMA..*_gcl_au*MTMyNjM0MzYyLjE3NTkzMTMwNDg."
                                        },
                                        {
                                            "text": "BREEZE Specialty Services",
                                            "href": "https://shop.trinityconsultants.com/software/specialty-modeling-services?_gl=1*2zj3ud*_ga*MTU5MjMwNjI4Ni4xNzU5MzEzMDQ4*_ga_E7GRZMZZT3*czE3NjEyMTU2NTUkbzE1JGcxJHQxNzYxMjE2OTkzJGo1OCRsMCRoMA..*_gcl_au*MTMyNjM0MzYyLjE3NTkzMTMwNDg."
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        "id": "training",
                        "title": "Training",
                        "href": "https://www.trinityconsultants.com/training/",
                        "type": "megamenu",
                        "content": {
                            "sections": [
                                {
                                    "title": "Education Program",
                                    "items": [
                                        {
                                            "text": "Overview",
                                            "href": "https://www.trinityconsultants.com/training/"
                                        },
                                        {
                                            "text": "Custom Training",
                                            "href": "https://www.trinityconsultants.com/request-custom-training/"
                                        }
                                    ]
                                },
                                {
                                    "title": "Training by Format",
                                    "items": [
                                        {
                                            "text": "Classroom",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByFormat%7CClassroom"
                                        },
                                        {
                                            "text": "Live Webinar",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByFormat%7CWebinar"
                                        },
                                        {
                                            "text": "Seminar",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByFormat%7CSeminar"
                                        },
                                        {
                                            "text": "On Demand",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByFormat%7COnDemand&pg=1"
                                        }
                                    ]
                                },
                                {
                                    "title": "Training by Topic",
                                    "items": [
                                        {
                                            "text": "Software",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByCategory%7CSoftware%20Courses&pg=1"
                                        },
                                        {
                                            "text": "Industry Specific",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByCategory%7CIndustry%20Specific&pg=1"
                                        },
                                        {
                                            "text": "EHS Regulations",
                                            "href": "https://shop.trinityconsultants.com/training/search?ds%5B0%5D=ByCategory%7CEHS%20Regulations&pg=1"
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        "id": "resources",
                        "title": "Resources",
                        "href": "https://www.trinityconsultants.com/resource-library",
                        "type": "megamenu",
                        "content": {
                            "title": "Resources",
                            "resource_types": [
                                {
                                    "text": "Case Studies",
                                    "href": "https://www.trinityconsultants.com/resource-library?resource_type=case-studies"
                                },
                                {
                                    "text": "Insights",
                                    "href": "https://www.trinityconsultants.com/resource-library?resource_type=insights"
                                },
                                {
                                    "text": "Service Sheets",
                                    "href": "https://www.trinityconsultants.com/resource-library?resource_type=service-sheets"
                                },
                                {
                                    "text": "Articles",
                                    "href": "https://www.trinityconsultants.com/resource-library?resource_type=articles"
                                },
                                {
                                    "text": "Blog",
                                    "href": "https://www.trinityconsultants.com/resource-library?resource_type=blog"
                                },
                                {
                                    "text": "Infographics",
                                    "href": "https://www.trinityconsultants.com/resource-library?resource_type=infographics"
                                },
                                {
                                    "text": "EHS Quarterly",
                                    "href": "https://trinityconsultants.com/resource-library?pages=1&per_page=18&resource_type=ehs-quarterly"
                                }
                            ],
                            "view_all": {
                                "text": "View All Resources",
                                "href": "https://www.trinityconsultants.com/resource-library"
                            },                          
                            "featured_content": [
                                {
                                    "title": "New Insight Spotlight: What Everyone's Talking About This Week",
                                    "description": "Exploring the headlines, trends, and talking points you need to know.",
                                    "cta": {
                                    "text": "Explore More",
                                    "href": "https://www.trinityconsultants.com/in-the-news/"
                                    }
                                },
                                {
                                    "title": "Watch our Videos",
                                    "description": "View our library of educational videos to learn how our services align with your regulatory needs.",
                                    "cta": {
                                    "text": "View Video Library",
                                    "href": "https://trinityconsultants.com/resource-library/videos/"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "id": "about_us",
                        "title": "About Us",
                        "href": "https://www.trinityconsultants.com/about-us/",
                        "type": "megamenu",
                        "content": {
                            "sections": [
                                {
                                    "title": "Our Purpose",
                                    "href": "https://www.trinityconsultants.com/our-purpose/",
                                    "items": [
                                        {
                                            "text": "Culture & Expertise",
                                            "href": "https://www.trinityconsultants.com/culture-expertise/"
                                        },
                                        {
                                            "text": "Leadership",
                                            "href": "https://www.trinityconsultants.com/leadership/"
                                        }
                                    ]
                                },
                                {
                                    "title": "Impact and Policies",
                                    "href": "https://www.trinityconsultants.com/impact-and-policies/",
                                    "items": [
                                        {
                                            "text": "Corporate Sustainability",
                                            "href": "https://www.trinityconsultants.com/impact-and-policies/#corp_sustain_sec"
                                        },
                                        {
                                            "text": "Environmental, Health, and Safety",
                                            "href": "https://www.trinityconsultants.com/impact-and-policies/#ehs_sec"
                                        },
                                        {
                                            "text": "Quality Assurance",
                                            "href": "https://www.trinityconsultants.com/impact-and-policies/#qa_sec"
                                        }
                                    ]
                                },
                                {
                                    "title": "Innovation",
                                    "href": "#",
                                    "items": [
                                        {
                                            "text": "Mergers & Acquisitions",
                                            "href": "https://www.trinityconsultants.com/mergers-acquisitions/"
                                        }
                                    ]
                                },
                                {
                                    "title": "In the News",
                                    "href": "https://www.trinityconsultants.com/in-the-news/",
                                    "items": [
                                        {
                                            "text": "Announcements",
                                            "href": "https://www.trinityconsultants.com/in-the-news/"
                                        },
                                        {
                                            "text": "Media Coverage",
                                            "href": "https://www.trinityconsultants.com/in-the-news/"
                                        },
                                        {
                                            "text": "Events",
                                            "href": "https://www.trinityconsultants.com/events/"
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        "id": "locations",
                        "title": "Locations",
                        "href": "https://www.trinityconsultants.com/locations/",
                        "type": "megamenu",
                        "content": {
                            "title": "Offices",
                            "regions": [
                                {
                                    "title": "United States",
                                    "href": "https://www.trinityconsultants.com/locations/?region=north_america&country=united_states",
                                    "states": [
                                        {
                                            "text": "Alabama",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/alabama"
                                        },
                                        {
                                            "text": "Arizona",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/arizona"
                                        },
                                        {
                                            "text": "Arkansas",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/arkansas"
                                        },
                                        {
                                            "text": "California",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/california"
                                        },
                                        {
                                            "text": "Colorado",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/colorado"
                                        },
                                        {
                                            "text": "Florida",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/florida"
                                        },
                                        {
                                            "text": "Georgia",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/georgia"
                                        },
                                        {
                                            "text": "Idaho",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/idaho"
                                        },
                                        {
                                            "text": "Illinois",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/illinois"
                                        },
                                        {
                                            "text": "Indiana",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/indiana"
                                        },
                                        {
                                            "text": "Iowa",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/iowa"
                                        },
                                        {
                                            "text": "Kansas",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/kansas"
                                        },
                                        {
                                            "text": "Kentucky",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/kentucky"
                                        },
                                        {
                                            "text": "Louisiana",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/louisiana"
                                        },
                                        {
                                            "text": "Maryland",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/maryland"
                                        },
                                        {
                                            "text": "Massachusetts",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/massachusetts"
                                        },
                                        {
                                            "text": "Michigan",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/michigan"
                                        },
                                        {
                                            "text": "Minnesota",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/minnesota"
                                        },
                                        {
                                            "text": "Mississippi",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/mississippi"
                                        },
                                        {
                                            "text": "Missouri",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/missouri"
                                        },
                                        {
                                            "text": "Montana",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/montana"
                                        },
                                        {
                                            "text": "Nebraska",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/nebraska"
                                        },
                                        {
                                            "text": "Nevada",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/nevada"
                                        },
                                        {
                                            "text": "New Jersey",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/new-jersey"
                                        },
                                        {
                                            "text": "New Mexico",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/new-mexico"
                                        },
                                        {
                                            "text": "New York",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/new-york"
                                        },
                                        {
                                            "text": "North Carolina",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/north-carolina"
                                        },
                                        {
                                            "text": "Ohio",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/ohio"
                                        },
                                        {
                                            "text": "Oklahoma",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/oklahoma"
                                        },
                                        {
                                            "text": "Oregon",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/oregon"
                                        },
                                        {
                                            "text": "Pennsylvania",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/pennsylvania"
                                        },
                                        {
                                            "text": "Puerto Rico",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/puerto-rico"
                                        },
                                        {
                                            "text": "South Carolina",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/south-carolina"
                                        },
                                        {
                                            "text": "Tennessee",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/tennessee"
                                        },
                                        {
                                            "text": "Texas",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/texas"
                                        },
                                        {
                                            "text": "Utah",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/utah"
                                        },
                                        {
                                            "text": "Virginia",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/virginia"
                                        },
                                        {
                                            "text": "Washington",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/washington"
                                        },
                                        {
                                            "text": "Washington D.C.",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/washington-dc"
                                        },
                                        {
                                            "text": "West Virginia",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/west-virginia"
                                        },
                                        {
                                            "text": "Wisconsin",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/wisconsin"
                                        },
                                        {
                                            "text": "Wyoming",
                                            "href": "https://trinityconsultants.com/locations/north-america/united-states/wyoming"
                                        }
                                    ]
                                },
                                {
                                    "title": "Asia",
                                    "href": "https://www.trinityconsultants.com/locations/?region=asia",
                                    "countries": [
                                        {
                                            "text": "China",
                                            "href": "https://trinityconsultants.com/asia/china"
                                        },
                                        {
                                            "text": "India",
                                            "href": "https://trinityconsultants.com/asia/india"
                                        },
                                        {
                                            "text": "Singapore",
                                            "href": "https://trinityconsultants.com/asia/singapore"
                                        }
                                    ]
                                },
                                {
                                    "title": "Europe",
                                    "href": "https://www.trinityconsultants.com/locations/?region=europe",
                                    "countries": [
                                        {
                                            "text": "Ireland",
                                            "href": "https://trinityconsultants.com/europe/ireland"
                                        },
                                        {
                                            "text": "United Kingdom",
                                            "href": "https://trinityconsultants.com/europe/united-kingdom"
                                        }
                                    ]
                                },
                                {
                                    "title": "North America",
                                    "href": "https://www.trinityconsultants.com/locations/?region=north_america",
                                    "countries": [
                                        {
                                            "text": "Canada",
                                            "href": "https://trinityconsultants.com/north_america/canada"
                                        },
                                        {
                                            "text": "United States",
                                            "href": "https://trinityconsultants.com/locations/?region=north-america&country=united-states"
                                        }
                                    ]
                                },
                                {
                                    "title": "Oceania",
                                    "href": "https://www.trinityconsultants.com/locations/?region=oceania",
                                    "countries": [
                                        {
                                            "text": "Australia",
                                            "href": "https://trinityconsultants.com/oceania/australia"
                                        }
                                    ]
                                }
                            ],
                            "view_all": {
                                "text": "View All Office Locations",
                                "href": "https://www.trinityconsultants.com/locations/"
                            }
                        }
                    }
                ],
                "mobile_items": [
                    {
                        "text": "Join Our Team",
                        "href": "#"
                    },
                    {
                        "text": "Subscribe",
                        "href": "#"
                    }
                ]
            },
            "signin_cta": {
                "text": "Sign In",
                "href": "https://shop.trinityconsultants.com/login"
            },
            "cta_button": {
                "text": "Contact Us",
                "href": "https://www.trinityconsultants.com/contact-us/"
            }
        }
    }
}